import { string, object, number, ObjectSchema } from 'yup';
import { IRoleAssignmentUpdate } from '@/features/role-assignments/interfaces';
import { ERROR_MAX_LENGTH, ERROR_REQUIRED_FIELD } from '@/constants';
import { createNameofProxy } from '@/utils';
import { ROLE_ASSIGNMENT_REMARKS_MAX_LENGTH } from './roleAssignment.constants';

export const ROLE_ASSIGNMENT_UPDATE_SCHEMA = object({
  profileId: string().required(ERROR_REQUIRED_FIELD),
  roleId: string().required(ERROR_REQUIRED_FIELD),
  status: number().required(ERROR_REQUIRED_FIELD),
  remarks: string().max(
    ROLE_ASSIGNMENT_REMARKS_MAX_LENGTH,
    ERROR_MAX_LENGTH(ROLE_ASSIGNMENT_REMARKS_MAX_LENGTH),
  ),
}) as ObjectSchema<IRoleAssignmentUpdate>;

export const ROLE_ASSIGNMENT_FORM_FIELDS = createNameofProxy<IRoleAssignmentUpdate>();
